import BaseIcon from '@/src/assets/icons'
import { BaseButton } from '../buttons/BaseButton'

import type { MonthValue } from '@/src/types/monthValue'
import { MONTHS_OPTIONS } from '@/src/utils/constants'
import { useTranslation } from 'react-i18next'
import { Menu, MenuButton, MenuGroup, MenuItem, MenuList } from '../ui/Menu'

interface MonthDropdownProps {
  value: MonthValue
  onChange: (value: string) => void
  minDate?: Date
  maxDate?: Date
  currentYear: number
}

export const DatePickerMonthDropdown = ({ value, onChange, minDate, maxDate, currentYear }: MonthDropdownProps) => {
  const { t } = useTranslation()
  const monthsWithLabels = MONTHS_OPTIONS.map(m => ({
    ...m,
    label: t(`months.${m.value}`),
    short: t(`months_short.${m.value}`),
  }))
  const selectedMonth = monthsWithLabels.find(option => option.value === value)

  const filteredMonths = monthsWithLabels.filter(month => {
    const monthIndex = MONTHS_OPTIONS.findIndex(m => m.value === month.value)
    const currentDate = new Date(currentYear, monthIndex)

    if (minDate && currentDate < new Date(minDate.getFullYear(), minDate.getMonth())) {
      return false
    }
    if (maxDate && currentDate > new Date(maxDate.getFullYear(), maxDate.getMonth())) {
      return false
    }
    return true
  })

  return (
    <Menu>
      <MenuButton
        as={BaseButton}
        pr='6px'
        isDisabled={filteredMonths.length <= 1}
        width='100%'
        size='small'
        variant='secondary'
        text={selectedMonth?.short ?? ''}
        iconRight={<BaseIcon name='chevronDown' />}
        sx={{ '.chakra-text': { minWidth: '27px', width: '100%', textAlign: 'left' } }}
      />
      <MenuList
        overflowY='auto'
        sx={{
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-track': {
            width: '6px',
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '24px',
          },
          scrollbarWidth: 'thin',
          scrollbarColor: '#888 #f1f1f1',
        }}
      >
        <MenuGroup>
          {filteredMonths.map(option => (
            <MenuItem
              value={option.value}
              key={option.value}
              class='standard'
              onClick={() => onChange(option.value)}
              isSelected={value === option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </MenuGroup>
      </MenuList>
    </Menu>
  )
}
